import { formatPhone } from 'src/lib/phone.utils'

import ContactSourceBadge from './ContactSourceBadge'
import type { KnownContact } from './knownContacts'

/**
 * One contact we hold, laid out like a carrier result: who they are on the
 * left, how to reach them on the right.
 */
const ContactOptionBody = ({ contact }: { contact: KnownContact }) => (
  <>
    <div className="flex min-w-0 flex-1 flex-col">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-xs font-medium text-doubleNickel-gray-800">
          {contact.contactName || 'Unnamed Contact'}
        </span>
        <ContactSourceBadge source={contact.source} />
      </div>
    </div>
    <div className="flex shrink-0 flex-col items-end text-right">
      {contact.email && (
        <span className="text-[11px] font-medium text-doubleNickel-gray-700">
          {contact.email}
        </span>
      )}
      {contact.phoneNumber && (
        <span className="text-[11px] text-doubleNickel-gray-500">
          {formatPhone(contact.phoneNumber)}
        </span>
      )}
    </div>
  </>
)

export default ContactOptionBody
